import codepen from "./codepen";
import codesandbox from "./codesandbox";
import instagram from "./instagram";
import soundcloud from "./soundcloud";
import youtube from "./youtube";
import vimeo from "./vimeo";
import twitter from "./twitter";
import pinterest from "./pinterest";

export default [
    codepen(),
    codesandbox(),
    instagram(),
    soundcloud(),
    youtube(),
    vimeo(),
    twitter(),
    pinterest()
];
